const dashboardDates = [
  'Today',
  'This week',
  'This month',
  'Yesterday',
  'Last week',
  'Last month',
];

export default dashboardDates;